import { createContext, useContext, type ReactNode } from "react";

export type DispensaryWorkspaceContextValue = {
  /** The active single location, or null in "All locations" mode / when none picked. */
  dispensaryId: string | null;
  /** The user's brand, when they're org-scoped (multi-location). Enables the aggregate view. */
  orgId: string | null;
  /** True when the user selected "All locations" (aggregate read across `orgId`). */
  allLocations: boolean;
  getToken: () => Promise<string | null>;
};

const Ctx = createContext<DispensaryWorkspaceContextValue | null>(null);

export function DispensaryWorkspaceProvider({
  value,
  children,
}: {
  value: DispensaryWorkspaceContextValue;
  children: ReactNode;
}) {
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useDispensaryWorkspace(): DispensaryWorkspaceContextValue {
  const v = useContext(Ctx);
  if (!v) {
    throw new Error("useDispensaryWorkspace must be used inside DispensaryWorkspaceProvider");
  }
  return v;
}
